import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HeadBar',
  props: {
    transparentBg: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    transparentBg?: boolean
}



return { __sfc: true,props }
}

})